var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { toDetail } from "@/helper/util";
import { EBillType } from "@/enum/EBillType";
var TabTable = (function (_super) {
    __extends(TabTable, _super);
    function TabTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.preview = [];
        return _this;
    }
    TabTable.prototype.mounted = function () {
        var _this = this;
        console.log('selectedList Change', this.selected, this.setSelected);
        if (this.selected.length && this.setSelected) {
            this.selected.forEach(function (item, index) {
                _this.$refs.subtable.toggleRowSelection(_this.list[index], true);
            });
        }
    };
    TabTable.prototype.toDeliver = function (row) {
        toDetail(EBillType.Deliver, row.delivery_order_id);
        document.querySelector('.v-modal').style.display = 'none';
    };
    TabTable.prototype.previewImage = function (row) {
        var _this = this;
        this.preview = row.document_pictures || [];
        if (this.preview.length) {
            this.$nextTick(function () {
                _this.$refs.image.clickHandler();
            });
        }
    };
    TabTable.prototype.subTableSelectionChange = function (rows, row) {
        this.$emit('selection-change', rows);
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], TabTable.prototype, "list", void 0);
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], TabTable.prototype, "selected", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], TabTable.prototype, "setSelected", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], TabTable.prototype, "showName", void 0);
    __decorate([
        Prop({
            type: String,
            default: '350px'
        })
    ], TabTable.prototype, "height", void 0);
    TabTable = __decorate([
        Component
    ], TabTable);
    return TabTable;
}(Vue));
export default TabTable;
